export const environment = {
  production: true,
  Build_Timestamp: '10/22/2026 04:53:24 PM CDT',
  envName: 'QA' // Added for verification
};
